import { Component, ElementRef } from '@angular/core';
import moment from 'moment';
import { Moment } from 'moment';
import { PageBase } from 't4core';
@Component({
  styleUrls: ['./ProductOverview.css'],
  selector: 'product-overview',
  templateUrl: './ProductOverview.html',
})
export class ProductOverviewComponent extends PageBase {
  constructor(el: ElementRef) {
    super(el, "ProductOverview");
  }


  private _fromDate: Moment = moment().startOf('month');
  private _toDate: Moment = moment().endOf('month');

  public get fromDate(): Moment { return this._fromDate; }
  public set fromDate(value: Moment) { this._fromDate = value; }

  public get toDate(): Moment { return this._toDate; }
  public set toDate(value: Moment) { this._toDate = value; }

  public async loadData() {
    this.fromDate = this.fromDate.clone();
  }

}
